import { profileLocal } from './profiles/local';

/** Tiles or a compact list on "My canvases". Remembered in the profile. */
const KEY = 'vp-home-layout';

export type HomeLayout = 'grid' | 'list';

export function readHomeLayout(): HomeLayout {
  try {
    return profileLocal.getItem(KEY) === 'list' ? 'list' : 'grid';
  } catch {
    return 'grid';
  }
}

export function writeHomeLayout(next: HomeLayout): void {
  try {
    profileLocal.setItem(KEY, next);
  } catch {
    /* private mode */
  }
}
